'use client';

import Spinner from '@carvana/ds-spinner';

export default function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '90vh'
      }}
    >
      <Spinner size="lg" />
    </div>
  );
}
